import React from 'react';
import TextComponent from 'shared/components/TextComponent';

const BGAPlacements = (props) => {
  const name = 'bga';

  const {
    label,
    errorMessage,
    parameters,
    inputId,
    tooltip,
    groupName,
    onChangeParameter,
    required,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      name={name}
      label={label}
      inputId={inputId}
      value={parameters[name]}
      tooltip={tooltip}
      required={required}
      groupName={groupName}
      onChange={onChange}
      errorMessage={errorMessage}
      disabled={disabled} />
  );
};

BGAPlacements.defaultProps = {
  label: Spree.translations.parameters.bga,
  tooltip: Spree.helpForParameters.bga,
  required: true,
  inputId: 'bga',
};

export default BGAPlacements;
